import { Navbar, Nav } from 'react-bootstrap'
import logo from '../assets/logo.svg'
import React, { useState, useEffect } from 'react'
import { useLocation } from 'react-router'
import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import { HiMenu } from "react-icons/hi";

const Navs = () => {
    const location = useLocation()
    const [activeSection, setActiveSection] = useState(location.pathname)
    const [navbarOpen, setNavbarOpen] = useState(false);
    console.log(navbarOpen)
    return (
        <header>
            <Navbar fixed="top" expand="lg">
                <Navbar.Brand href="#home">
                    <img
                        src={logo}
                        width="50"
                        height="50"
                        className="d-inline-block align-top"
                        alt="Vishal Codes"
                    />
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav activeKey={activeSection}>
                        <Link className={ activeSection === '/' ? "nav-link active" : "nav-link"} onClick={() => setActiveSection('/')} to="/">HOME</Link>
                        <Link className={activeSection === '/about' ? "nav-link active" : "nav-link"} onClick={() => setActiveSection('/about')} to="/about">ABOUT</Link>
                        <Link className={ activeSection==='/resume' ? "nav-link active" : "nav-link"} onClick={() => setActiveSection('/resume')} to="/resume">RESUME</Link>
                        <Link className={ activeSection==='/portfolio' ? "nav-link active" : "nav-link"} onClick={() => setActiveSection('/portfolio')} to="/portfolio">PORTFOLIO</Link>
                        {/* <Link className={ activeSection==='/testimonial' ? "nav-link active" : "nav-link"} onClick={() => setActiveSection('/testimonial')} to="/testimonial">TESTIMONIAL</Link>
                        <Link className={ activeSection==='/blog' ? "nav-link active" : "nav-link"} onClick={() => setActiveSection('/blog')} to="/blog">BLOG</Link> */}
                        <Link className={ activeSection==='/contact' ? "nav-link active" : "nav-link"} onClick={() => setActiveSection('/contact')} to="/contact">CONTACT</Link>
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
        </header>
    )
}
// {activeSection==='/' ? className="nav-link active" : className="nav-link"}
// data-rb-event-key="/service" class="nav-link"

export default Navs;